/* eslint-disable arrow-parens */
/* eslint-disable implicit-arrow-linebreak */

/**
 * The global state selectors
 */

import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectChangePlan = state => state.changePlan || initialState

const makeSelectChangePlan = () =>
  createSelector(
    selectChangePlan,
    state => state
  )

export {
  selectChangePlan,
  makeSelectChangePlan
}
